"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityNetworkBanner = exports.EntityNetworkBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var banner_controls_1 = require("../elements/banner-controls");
var entity_type_title_1 = require("./entity-type-title");
var image_fill_1 = require("./image-fill");
var cell_label_1 = require("../elements/cell-label");
exports.EntityNetworkBannerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    background: ", ";\n    flex-direction: row;\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: flex;\n    background: ", ";\n    flex-direction: row;\n    border-bottom: 1px solid ", ";\n  "])), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('line-subtle'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", "px;\n    height: 68px;\n  "], ["\n    width: ", "px;\n    height: 68px;\n  "])), 1184 / 10)
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    padding: ", " ", ";\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    padding: ", " ", ";\n    justify-content: space-between;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4)),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Image: (0, styled_components_1.default)(image_fill_1.ImageFill)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Info: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Title: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Name: (0, styled_components_1.default)(entity_type_title_1.EntityTypeTitle)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Controls: (0, styled_components_1.default)(banner_controls_1.BannerControls)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
var EntityNetworkBanner = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    banner = props.banner,
    controls = props.controls;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var t = (0, use_lang_1.useLang)();
  var title = definition ? (0, sprintf_js_1.sprintf)(t('Network'), definition.label) : t('Please wait...');
  var hasImage = banner && banner.image;
  return react_1.default.createElement(My.Container, {
    className: className
  }, hasImage && react_1.default.createElement(My.Image, {
    entity: banner.image
  }), react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Info, null, react_1.default.createElement(My.Title, null, title), react_1.default.createElement(My.Name, {
    size: "small",
    entityTypeName: entityTypeName
  })), controls && react_1.default.createElement(My.Controls, {
    items: controls
  })));
};
exports.EntityNetworkBanner = EntityNetworkBanner;
exports.EntityNetworkBanner.defaultProps = exports.EntityNetworkBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;